import { render, staticRenderFns } from "./SectionClasses.vue?vue&type=template&id=6d53384e&"
import script from "./SectionClasses.vue?vue&type=script&lang=js&"
export * from "./SectionClasses.vue?vue&type=script&lang=js&"
import style0 from "./SectionClasses.vue?vue&type=style&index=0&id=6d53384e&prod&scss=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports